<div style="padding: 3%;">
    <div style="display: flex;justify-content: space-between;align-items: center;padding: 3px 0px;">
        <div class="coupon_heading">Avaliable Coupons</div>
        <div style="font-weight: bold;cursor: pointer;"
            (click)="onNoClick()">X</div>
    </div>
    <div style=" order: 1px solid grey;"></div>
    <div class="coupon_container">
        <div class="coupons-wrapper">
            <div  *ngFor="let promo of PromoCodeData; let i = index">
                <div class="coupons">
                    <div style="text-align: center;font-size: 18px;">PROMO</div>
                    <div style="border-bottom: 1px solid var(--primary-color);margin:5px 10px;"></div>
                    <div class="coupon_border">
                        <div class="inner_content">
                            <div class="flat_header">FLAT</div>
                            <div class="coupon_percentage">{{ promo.Percentage }}%</div>
                            <!-- <div class="coupon_amount">Amount: {{ promo.Amount}}</div> -->
                        </div>
                    </div>
                </div>
                <div (click)="applyOffer(i)" class="coupon_apply">Apply this</div>
            </div>
        </div>
    </div>
</div>
